import { useState } from "react";
import { KeyRound, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/api";

export const ChangePasswordDialog = ({ onClose }) => {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.new_password.length < 8) return setError("Yeni şifre en az 8 karakter olmalı");
    if (form.new_password !== form.confirm) return setError("Yeni şifreler birbiriyle uyuşmuyor");
    setBusy(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password, new_password: form.new_password,
      });
      toast.success("Şifreniz güncellendi");
      onClose();
    } catch (err) {
      setError(errMsg(err));
    }
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-zinc-950/40 p-4 backdrop-blur-sm"
      data-testid="change-password-dialog">
      <form onSubmit={submit} className="brut w-full max-w-md animate-fade-up p-6 shadow-hard-lg">
        <div className="flex items-start justify-between">
          <div>
            <p className="overline">Hesap Güvenliği</p>
            <h2 className="mt-1 font-display text-2xl font-black tracking-tighter">Şifre Değiştir</h2>
          </div>
          <button type="button" onClick={onClose} data-testid="change-password-close" className="text-zinc-400 hover:text-zinc-950">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="mt-5 space-y-4">
          <div>
            <label className="overline">Mevcut Şifre</label>
            <input type="password" required className="brut-input mt-1.5" value={form.current_password}
              onChange={(e) => setForm({ ...form, current_password: e.target.value })}
              data-testid="current-password-input" />
          </div>
          <div>
            <label className="overline">Yeni Şifre (en az 8 karakter)</label>
            <input type="password" required className="brut-input mt-1.5" value={form.new_password}
              onChange={(e) => setForm({ ...form, new_password: e.target.value })}
              data-testid="new-password-input" />
          </div>
          <div>
            <label className="overline">Yeni Şifre (tekrar)</label>
            <input type="password" required className="brut-input mt-1.5" value={form.confirm}
              onChange={(e) => setForm({ ...form, confirm: e.target.value })}
              data-testid="confirm-password-input" />
          </div>
          {error && (
            <p className="border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="change-password-error">
              {error}
            </p>
          )}
        </div>
        <button type="submit" disabled={busy} className="brut-btn mt-6 w-full" data-testid="change-password-submit">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />} Şifreyi Güncelle
        </button>
      </form>
    </div>
  );
};

export default ChangePasswordDialog;
